<div class="verification-tractors-page">
    <div class="container">
        <div class="info-content hide-mobile">
            <div class="info">
                <div class="portalLogo" (click)="gotoHome()" style="cursor: pointer;" title="Home"></div>
                <h3 class="my-5">{{ _translateService.Keys.VERIFICATION_TRACTORS_TITLE | translate }}</h3>
                <self-ins-policies-and-request-page></self-ins-policies-and-request-page>
            </div>
            <contacts></contacts>
        </div>
        <div class="main-content">
            <div class="table-cont">
                <p class="m-0 hide-mobile">{{ _translateService.Keys.VERIFICATION_TRACTORS_SUBTITLE | translate }}</p>
                <div class="searchBar">
                    <input
                        id="search"
                        class="form-input"
                        placeholder="{{ _translateService.Keys.COMMON_SEARCH | translate }}"
                        (keyup)="applyFilter()"
                        [(ngModel)]="gridFilterValue"
                        spellcheck="false"
                    />
                    <button
                        *ngIf="gridFilterValue && gridFilterValue.length > 0"
                        class="clear-search-btn"
                        (click)="clearSearch()"
                        type="button"
                    >
                        <img src="../../../assets/close.svg" alt="clear search" width="16" height="16">
                    </button>
                    <label
                        for="search"
                        class="form_label"
                    >{{ _translateService.Keys.COMMON_SEARCH | translate }}
                    </label>
                </div>
                <div class="table-wrapper">
                    <table mat-table matSort [dataSource]="tractors">
                    <ng-container matColumnDef="vin">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ _translateService.Keys.VERIFICATION_TRACTORS_VIN | translate }}</th>
                        <td mat-cell *matCellDef="let element"> {{element.vin}} </td>
                    </ng-container>
                    <ng-container matColumnDef="year">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ _translateService.Keys.VERIFICATION_TRACTORS_YEAR | translate }}</th>
                        <td mat-cell *matCellDef="let element"> {{element.year}} </td>
                    </ng-container>
                    <ng-container matColumnDef="make">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ _translateService.Keys.VERIFICATION_TRACTORS_MAKE | translate }}</th>
                        <td mat-cell *matCellDef="let element"> {{element.make}} </td>
                    </ng-container>
                    <ng-container matColumnDef="equipmentId">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ _translateService.Keys.VERIFICATION_TRACTORS_EQUIPMENT_ID | translate }}</th>
                        <td mat-cell *matCellDef="let element"> {{element.equipmentId}} </td>
                    </ng-container>
                    <ng-container matColumnDef="fuelType">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ _translateService.Keys.VERIFICATION_TRACTORS_FUEL_TYPE | translate }}</th>
                        <td mat-cell *matCellDef="let element"> {{element.fuelType}} </td>
                    </ng-container>
                    <ng-container matColumnDef="pickupDate">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ _translateService.Keys.VERIFICATION_TRACTORS_PICKUP_DATE | translate }}</th>
                        <td mat-cell *matCellDef="let element"> {{element.pickupDate | date: dateFormat: currentLocale}} </td>
                    </ng-container>
                    <ng-container matColumnDef="returnDate">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ _translateService.Keys.VERIFICATION_TRACTORS_RETURN_DATE | translate }}</th>
                        <td mat-cell *matCellDef="let element"> {{element.returnDate | date: dateFormat: currentLocale}} </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row class="table-row" *matRowDef="let row; columns: displayedColumns;"></tr>
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell noData text-center" colspan="10">{{ _translateService.Keys.VERIFICATION_TRACTORS_NO_DATA_FILTER | translate: {filter: gridFilterValue} }}</td>
                    </tr>
                </table>
                </div>
                <div class="table-actions mt-2">
                    <p class="m-0">
                        <a [href]="'mailto:' + supportEmail + '?subject=' + (user?.verificationInfo?.insuredName || '')">
                            {{ _translateService.Keys.VERIFICATION_REPORT | translate }}
                        </a>
                        {{ _translateService.Keys.VERIFICATION_INCORRECT_INFO | translate }}
                    </p>
                </div>
            </div>
            <div class="actions pt-3 hide-mobile">
                <button class="primary-button"
                    [routerLink]="['/coverage']"
                    [queryParams]="{ qnum: qnum, qsuffix: qsuffix }">
                    {{ _translateService.Keys.COMMON_BACK | translate }}
                </button>
            </div>
        </div>
    </div>
</div>
